import React from "react";
import Autocomplete from "../../generic/autocomplete";
import EdButton from "../../generic/edButton";
import InputField from "../../generic/inputField";
import { betweenNChars, emailRegex, phoneNo } from "../../utils/regex";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

const SignupForm = (props) => {
  const {
    signupModal,
    show_modal_Fun,
    onChangeSignupForm,
    handleACBlur,
    signupErr,
    setSignupErr,
    cities,
    submitSignupForm,
    signupFormVal,
    clientCode,
    setClientCode,
  } = props;

  return (
    <div>
      <div
        id={signupModal && signupModal.isOpen ? "show_modal" : "hide_modal"}
        className="modal_signup"
      >
        <div className="modal_content_signup">
          <div className="signup_form_header">
            <div className="close_logo">
              <span onClick={() => show_modal_Fun(false, "")}>
                <i className="edel-icon-close"></i>
              </span>
            </div>
            <div className="edelwiess_logo">
              <span>
                <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
              </span>
              <span onClick={() => show_modal_Fun(false, "")}>
                <i className="edel-icon-close"></i>
              </span>
            </div>
            <h1>We shall get in touch with you to get started.</h1>
            <p>Quick, fast and simple</p>
          </div>
          <form className="signup_form" onSubmit={submitSignupForm}>
            <label className="inp_lbl mg-b5 ib">Name</label>
            <InputField
              pattern={betweenNChars(3)}
              onChange={(value) => onChangeSignupForm("nm", value)}
              onBlur={(error) =>
                setSignupErr({
                  ...signupErr,
                  nm: error.pattern ? "" : "Please enter at least 3 character",
                })
              }
              defaultValue={signupFormVal.nm}
              className="login_inp mg-b40"
              placeholder="Eg: Name Surname"
              errorText={signupErr.nm}
            />

            <label className="inp_lbl mg-b5 ib">Email ID</label>
            <InputField
              pattern={emailRegex}
              onChange={(value) => onChangeSignupForm("eml", value)}
              onBlur={(error) =>
                setSignupErr({
                  ...signupErr,
                  eml: error.pattern ? "" : "Please enter a valid email id",
                })
              }
              defaultValue={signupFormVal.eml}
              className="login_inp mg-b40"
              placeholder="Eg: example@email.com"
              errorText={signupErr.eml}
            />

            <label className="inp_lbl mg-b5 ib">Phone Number</label>
            <div className="phone_no">
              <span className="cntry_code mg-b30 ib mg-r20">+91</span>
              <InputField
                type="tel"
                pattern={phoneNo}
                onChange={(value) => onChangeSignupForm("phNo", value)}
                onBlur={(error) =>
                  setSignupErr({
                    ...signupErr,
                    phNo: error.pattern
                      ? ""
                      : "Please enter a valid phone number",
                  })
                }
                defaultValue={signupFormVal.phNo}
                className="login_inp mg-b30"
                placeholder="Eg: 980908XXXX"
                errorText={signupErr.phNo}
              />
            </div>

            <label className="inp_lbl mg-b5 ib">City</label>
            {/* We have to store state also along with city because state is required in api request.
					Index of cities is not stored in value because it may change when user clicks on a city (api is called again)
					That is why both city and state are stored in value
					This also helps to check if the value in input is typed by the user or selected from the dropdown */}
            <Autocomplete
              data={
                cities
                  ? cities.map((city) => ({
                      value: city.city + ";" + city.state,
                      display: city.city,
                    }))
                  : null
              }
              onOptionSelect={(value) =>
                onChangeSignupForm("city", value.value)
              }
              noDataMsg="City with similar name not found"
              onChange={(value) => onChangeSignupForm("city", value)}
              inputClassName="login_inp mg-b40"
              placeholder="Eg: Mumbai"
              onBlur={handleACBlur}
              name="city"
              defaultValue={signupFormVal.city}
              className="city"
              errorText={signupErr.city}
            />

            <label className="inp_lbl mg-b5 ib">Client Code (Optional)</label>
            <InputField
              pattern={betweenNChars(3)}
              alphanum
              onChange={(value) => setClientCode(value)}
              onBlur={() => {}}
              defaultValue={clientCode}
              className="login_inp mg-b40"
              placeholder="Eg: Example123"
              errorText={""}
            />

            <EdButton
              value="Request a Call"
              type="submit"
              btnTyp="primary"
              className="submit_btn"
              disabled={
                Object.values(signupErr).every((error) => error) ||
                Object.values(signupFormVal).some((value) => !value) ||
                props.disableForm
              }
            />
          </form>
          <div className="form_btn text_btn">
            <button onClick={() => show_modal_Fun(false, "")}> Cancel</button>
          </div>
          <div className="mob_footer">
            <EdButton
              value="Request a Call"
              type="button"
              btnTyp="primary"
              className="submit_btn"
              onClick={submitSignupForm}
              disabled={
                Object.values(signupErr).every((error) => error) ||
                Object.values(signupFormVal).some((value) => !value) ||
                props.disableForm
              }
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
